module.exports = __webpack_public_path__ + "static/img/guide-vertical.56e6ef29.png";